import { SiteDto } from '@admin/models/site-dto';
import { SiteActions, SiteActionTypes } from '@app/core/store/actions/site.action';

export const initialState: SiteState = {
  sites: [],
  siteDetail: null,
};

export interface SiteState {
  sites: SiteDto[];
  siteDetail: SiteDto | null;
}

export function siteReducer(state: SiteState = initialState, action: SiteActions): SiteState {
  switch (action.type) {
    case SiteActionTypes.LoadSitesSuccess:
      return {
        ...state,
        sites: action.sites,
      };
    case SiteActionTypes.GetSiteSuccess:
      return {
        ...state,
        siteDetail: action.site,
      };
    case SiteActionTypes.UpdateSiteSuccess:
      return {
        ...state,
        siteDetail: action.site,
      };
    default:
      return state;
  }
}
